import { AuthenticatedHttpClient } from "@/lib/axios";
import { DashboardStatistics } from "@/types/dashboard.types";

// Helper function to format date as YYYY-MM-DD in local timezone (not UTC)
const formatDateLocal = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export class DashboardService {
  private http: AuthenticatedHttpClient;

  constructor(httpClient: AuthenticatedHttpClient) {
    this.http = httpClient;
  }

  async getDashboardStatistics(startDate: Date, endDate: Date) {
    const response = await this.http.get(
      `/statistics/dashboard?startDate=${formatDateLocal(startDate)}&endDate=${formatDateLocal(endDate)}`
    );
    return response as unknown as DashboardStatistics;
  }
}
